import type * as React from 'react';
import { get } from '@Domain/Api';
import aiCostBreakdownFetched, {
	type AiCostBreakdownFetchedAction,
	type AiCostBreakdownFetchedPayload,
} from '@Application/AiCosts/Actions/aiCostBreakdownFetched';
import aiCostBreakdownFetchFailed, {
	type AiCostBreakdownFetchFailedAction,
} from '@Application/AiCosts/Actions/aiCostBreakdownFetchFailed';
import type FetchAiCostBreakdown from '@Application/AiCosts/Queries/FetchAiCostBreakdown';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = AiCostBreakdownFetchedAction | AiCostBreakdownFetchFailedAction;

export default (query: FetchAiCostBreakdown) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// Server-side pagination: `get` is used deliberately, never `getPaginated`, so `totalRecords`
			// stays the true total.
			const baseUrl = `${parameters.api.host}/api/accounts/${query.accountId}/ai-costs/${query.dimension}`;
			const queryString = query.toQueryString();
			const url = queryString.length > 0 ? `${baseUrl}?${queryString}` : baseUrl;

			const payload = await get<AiCostBreakdownFetchedPayload>(url);

			const action = aiCostBreakdownFetched(
				payload,
				query.dimension,
				query.accountId,
				query.queryKey,
				query.page,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiCostBreakdownFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
